import React from 'react';
import {observer} from "mobx-react";
import {NewsWidgetAsync} from "../../../news-widget/components/news-widget.async";
import styles from "../../styles/game-center-widget.module.scss";
import classNames from "classnames";

export const GameCenterWidgetContentNewsTab = observer(({controller, gameId}) => {
  const {state} = controller;
  const {shouldRenderNews} = state;

  const newsProps = {
    shouldRenderSeeAll: true,
    gamesIds: [gameId],
  }
  return (shouldRenderNews ? <>
    <div className={classNames(styles.widget_wrapper)}>
      <NewsWidgetAsync {...newsProps}/>
    </div>
  </> : null)
});
